import ErrorTemplate from "../../components/error-template";
import { Button } from "@acesso-io/genoma-ui";
import { useTranslation } from '@frontend/feature-i18n';
import PropTypes from 'prop-types';
import AppErrorIcon from '../../../assets/images/AppErrorIcon.svg';
import { NEW_TAB_REL, NEW_TAB_TARGET } from "../../utils/constants";
import { primaryButtonStyles, secondaryButtonStyles } from "./styles";

const DEFAULT_HELP_URL = "https://empresas.unico.io/hc/pt-br";

const DEFAULT_MESSAGE_KEY = "ContactSupport";
const DEFAULT_MESSAGE_FALLBACK =
  "Você pode tentar novamente atualizando a página. Se o erro persistir, entre em contato com nosso suporte.";

const Error5xx = ({
  helpUrl = DEFAULT_HELP_URL,
  messageKey = DEFAULT_MESSAGE_KEY,
  messageFallback = DEFAULT_MESSAGE_FALLBACK,
  showTryAgain = true,
}) => {
  const { getTranslationAsString } = useTranslation();

  const handleTryAgain = () => {
    window.location.reload();
  };

  const handleSupport = () => {
    window.open(helpUrl, NEW_TAB_TARGET, NEW_TAB_REL);
  };

  return (
    <ErrorTemplate
      errorCode='5xx'
      image={AppErrorIcon}
      imageClassName='error-icon'
      title={getTranslationAsString('SystemMisbehaved', {}, 'Tivemos um erro ao carregar esta página')}
      actions={
        <>
          {showTryAgain && (
            <Button
              variant="contained"
              onClick={handleTryAgain}
              sx={primaryButtonStyles}
            >
              {getTranslationAsString('TryAgain', {}, 'Tentar novamente')}
            </Button>
          )}
          <Button
            variant="text"
            onClick={handleSupport}
            sx={secondaryButtonStyles}
          >
            {getTranslationAsString('Support', {}, 'Suporte')}
          </Button>
        </>
      }
    >
      <span>
        {getTranslationAsString(messageKey, {}, messageFallback)}
      </span>
    </ErrorTemplate>
  );
};

Error5xx.propTypes = {
  helpUrl: PropTypes.string,
  messageKey: PropTypes.string,
  messageFallback: PropTypes.string,
  showTryAgain: PropTypes.bool,
};

export default Error5xx;
